import * as React from 'react';
import * as Images from 'pos/Images';

import { Res } from 'core/api';
import { Cordova } from 'pos/common';
import { Modal } from 'core/ui-next/modal';
import { PosStatelessScreenClassComponent } from 'pos/ui/PosScreenClassComponent';
import { ActionButtonDefinition, ScreenSize } from 'pos/ui';

class QRScanner extends PosStatelessScreenClassComponent<Modal.Actions<string>> {

	private scanningTimeout: Nullable<NodeJS.Timeout> = null;

	constructor(props: Modal.Actions<string>) {
		super(props);
	}

	protected getScreenId(): string {
		return 'QR_SCANNER';
	}

	protected getTitle(): string {
		return Res.Web.QR_SCAN();
	}

	protected getImage(): string | SvgIcon {
		return Images.SearchBarcode;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(() => this.requestDismiss()),
			null,
			null,
			null,
			null,
			null
		];
	}

	protected getContent(): React.ReactNode {
		return <>
		</>;
	}

	protected async requestDismiss(): Promise<void> {
		await this.cancelScanner();
	}

	async cancelScanner(): Promise<void> {
		await Cordova.cancelQRScan();
		await Cordova.closeQRScanner();
		document.body.classList.remove('scanning');
		return this.cancel();
	}

	async startScanning() {
		await Cordova.openQRScanner();
		document.body.classList.add('scanning');

		const qrValue = await Cordova.scanQRCode();

		await Cordova.closeQRScanner();
		document.body.classList.remove('scanning');

		this.close(qrValue);
	}

	async onComponentDidMount(): Promise<void> {
		// Lanzamos el escaneo en un setTimeout para que funcione correctamente con el
		// React.StrictMode que usamos en desarrollo y que fuerza un doble mount/unmount.
		// De esta forma, hasta que no se ha quedado montada la pantalla de verdad, no
		// se inicia el escaneo, y durante el primer desmontado se limpia el timeout en
		// el willUnmount evitando que haya reentradas en a nivel de cordova.
		this.scanningTimeout = setTimeout(() => this.startScanning(), 50);
	}

	onComponentWillUnmount(): void {
		this.scanningTimeout && clearTimeout(this.scanningTimeout);
	}
}

export async function read(): Promise<Result<string>> {
	return Modal.show(QRScanner);
}
